module.exports = __webpack_public_path__ + "static/media/CHASIU_MENU-normal.b04b3145.png";